export function parseChartPayload(raw, depth = 0) {
    if (depth > 4 || raw === null || raw === undefined)
        return null;
    if (typeof raw === "string") {
        // Strip markdown code fences (```json ... ``` or ``` ... ```)
        const stripped = raw
            .replace(/^```(?:json)?\s*/i, "")
            .replace(/\s*```$/, "")
            .trim();
        try {
            return parseChartPayload(JSON.parse(stripped), depth + 1);
        }
        catch {
            return null;
        }
    }
    if (typeof raw === "object") {
        const o = raw;
        if (o.plot_type === "pie") {
            // Case 1: flat labels/values arrays
            if (Array.isArray(o.labels) && Array.isArray(o.values)) {
                return o;
            }
            // Case 2: series[].data[{name, value}] — AI's actual response format
            const series = o.series;
            if (Array.isArray(series) && series[0]?.data) {
                const data = series[0].data;
                return {
                    colors: o.colors,
                    labels: data.map((d) => d.name),
                    plot_type: "pie",
                    title: String(o.title ?? ""),
                    values: data.map((d) => d.value)
                };
            }
        }
        for (const val of Object.values(o)) {
            const found = parseChartPayload(val, depth + 1);
            if (found)
                return found;
        }
    }
    return null;
}
